export enum ZoomLevel {
    L100 = 1,
    L110 = 1.1,
    L120 = 1.2,
    L130 = 1.3,
    L140 = 1.4,
    L150 = 1.5,
  }